export default "__VITE_ASSET__DIfMshAg__"